/**
 * @return {string}
 */

export default function LowerCaseText(text) {
  if (text) {
    return text.toLowerCase();
  } else return "";
}
